import { gql } from '@apollo/client';

export const GET_PROGRAMME_REPORTER_ASSIGNEES = gql`
  query GetProgrammeReporterAssignees($input: ProgrammeReporterAssigneesInput!) {
    assignees: getProgrammeReporterAssignees(input: $input) {
      id
      firstName
      lastName
    }
  }
`;
